import { createAction } from 'helpers/actionHelpers/createAction'

export class AutoinvestmentsModeDisableAction extends (
  createAction<'AUTOINVESTMENTS_MODE_DISABLE', void>('AUTOINVESTMENTS_MODE_DISABLE')
) {}

export type AutoinvestmentsModeActions =
  | AutoinvestmentsModeDisableAction
